<template>
     <span>{{calculateDuration}}</span>
</template>

<script>

import ClientService from "@/services/ClientService";
import UtilService from "@/services/UtilService";

export default {
  name: 'CellRendererActions',
   data() {
    return {
      duration: '',
    };
    },
    computed: {
    calculateDuration(){
      return this.params.data.Duration >1  ?  this.params.data.Duration + ' days' : this.params.data.Duration + ' day'
    }
  }
}
</script>
